import { Flex } from '@lemonade-hq/cdk';
import Image from 'next/image';
import googlePlayLogo from '@/static/assets/download_links/googlePlay.svg';
import appStoreLogo from '@/static/assets/download_links/appStore.svg';
import React from 'react';
import styled from 'styled-components';

const Link = styled.a`
  &:hover {
    text-decoration: none;
  }
`;

const AppDownloadLinks: React.FC = () => (
  <Flex gap="12px" justifyContent="center">
    <Link
      aria-label="Download the Lemonade app on the App Store"
      href="https://lemonadeinc.onelink.me/2551691193/84bca19b"
      rel="noopener noreferrer"
      target="_blank"
    >
      <Image height={40} width={120} src={appStoreLogo} alt="App Store" quality={100} />
    </Link>
    <Link
      aFlexria-label="Download the Lemonade app on Google Play"
      href="https://lemonadeinc.onelink.me/2832583367/6a83b39e"
      rel="noopener noreferrer"
      target="_blank"
    >
      <Image height={40} width={135} src={googlePlayLogo} alt="Google Play" quality={100} />
    </Link>
  </Flex>
);

AppDownloadLinks.displayName = 'AppDownloadLinks';

export default AppDownloadLinks;
